import { useGraphQLQuery } from '@opengov/bnp-core';
import { useToast } from '../../../Toast/context/useToast.context';
import { HASURA_SERVICE_URL } from '../../../../../config/config';
import { graphql } from '../../../../../gql-generated/hasura';
import { SpreadsheetStoryCounts_Bool_Exp } from '../../../../../gql-generated/hasura/graphql';
import locale from '../customReports-locale.json';
import { customReportsQueryKeys } from './customReportsQueryKeys';

const FetchCustomReportStoryCounts = graphql(`
  query GetCustomReportStoryCounts($where: spreadsheetStoryCounts_bool_exp) {
    spreadsheetStoryCounts(where: $where) {
      ...CustomReportsTable_StoryCountFragment
    }
  }
`);

type UseFetchCustomReportStoryCountsOptions = {
  spreadsheetIds: string[];
};

export function useFetchCustomReportStoryCounts({ spreadsheetIds }: UseFetchCustomReportStoryCountsOptions) {
  const { toggleToast } = useToast();
  const whereClause: SpreadsheetStoryCounts_Bool_Exp = {
    spreadsheetId: { _in: spreadsheetIds }
  };

  return useGraphQLQuery({
    queryKey: customReportsQueryKeys.customReportStoryCounts(spreadsheetIds),
    variables: { where: whereClause },
    document: FetchCustomReportStoryCounts,
    url: HASURA_SERVICE_URL,
    options: {
      select: (data) => data?.spreadsheetStoryCounts,
      enabled: spreadsheetIds.length > 0,
      onError: (error) => {
        console.error(error);
        toggleToast({
          title: locale.errors.somethingWentWrong,
          body: locale.errors.unableToFetchCustomReports,
          severity: 'error'
        });
      }
    }
  });
}
